import { UploadIcon } from '@/imports/ui/chakra/feather';
import {
  Box,
  Button,
  Center,
  CenterProps,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone';

export const DragAndDropImageUploader: React.FC<
  {
    isDragActive: boolean;
    isLoading: boolean;
    getInputProps: (
      props?: DropzoneInputProps | undefined
    ) => DropzoneInputProps;
    getRootProps: (props?: DropzoneRootProps | undefined) => DropzoneRootProps;
    isDisabled?: boolean;
    newView?: boolean;
    imageSizeSmall?: boolean;
    imageSizeLarge?: boolean;
  } & CenterProps
> = ({
  isDragActive,
  isLoading,
  getInputProps,
  getRootProps,
  isDisabled,
  newView = false,
  imageSizeSmall = false,
  imageSizeLarge = false,
  ...centerProps
}) => {
  return (
    <Center
      bg={newView ? "secondary.500" : "gray.50"}
      borderRadius="sm"
      borderStyle={newView ? 'dashed' : 'solid'}
      borderWidth={newView ? '2px' : '1px'}
      borderColor={isDragActive ? (newView ? "primary.500" : "gray.300") : (newView ? "secondary.500" : "gray.50")}
      cursor={isDragActive ? 'add' : 'default'}
      minH="177px"
      {...getRootProps()}
      {...centerProps}
    >
      {isLoading ? (
        <Spinner color="primary.500" />
      ) : (
        <VStack spacing="2">

            {newView && (
              <Box  bg="White" color="primary.500" px="2" w="40px" h="40px" py="1" borderRadius="full" display="flex" alignItems="center" justifyContent="center">
                <UploadIcon w="40px" h="40px"/>
              </Box>
            )}
          <Text color={newView ? "textPrimary.500" : "gray.500"} fontWeight="medium">
            {'Drag & drop an image'} {newView ? 'Or' : ''}
          </Text>
          {!newView && (
          <Text color={newView ? "textPrimary.500" : "gray.500"} textStyle="bodyStrong">
            or
          </Text>)}
          <input {...getInputProps()} />
          <Button
            variant={newView ? "ghost" : "outline"}
            colorScheme={newView ? "primary" : "gray"}
            _hover={{ bg: newView ? "secondary.500" : "gray.100" }}
            size="sm"
            isDisabled={isDisabled}
          >
            Upload New
          </Button>
          
          {imageSizeSmall && (
          <Text color={newView ? "textPrimary.500" : "gray.500"} fontSize="sm">
            The image size is 300px by 300px
          </Text>
          )}

           {imageSizeLarge && (
          <Text color={newView ? "textPrimary.500" : "gray.500"} fontSize="sm">
            The image size is 1600px by 600px
          </Text>
          )}
        </VStack>
      )}
    </Center>
  );
};
